import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PriceBlock() {
  return <section className="py-6 px-4 bg-navy text-cream text-center" data-id="element-317">
      <div className="max-w-md mx-auto" data-id="element-318">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white/5 backdrop-blur-md p-6 rounded-2xl border border-white/10 space-y-4" data-id="element-319">
          {/* Label */}
          <p className="text-xs text-cream/60 uppercase tracking-widest font-medium" data-id="element-320">
            Lo que recibes hoy
          </p>

          {/* Value line */}
          <p className="text-xl md:text-2xl font-serif font-bold text-cream leading-snug" data-id="element-321">
            El libro + 3 bonos de implementación
          </p>

          {/* Prices */}
          <div className="space-y-1" data-id="element-322">
            <p className="text-base text-cream/40 line-through" data-id="element-323">
              Valor real: $104.00
            </p>
            <div className="flex items-baseline justify-center gap-2" data-id="element-324">
              <span className="text-5xl font-bold text-white" data-id="element-325">$6.39</span>
              <span className="text-xl text-cream/60" data-id="element-326">USD</span>
            </div>
          </div>

          {/* Sub-line */}
          <p className="text-sm text-cream/60" data-id="element-327">
            Descarga instantánea. Acceso inmediato a todo.
          </p>

          {/* Button */}
          <a href="https://tucambiohoy.online/cart/43004276899953:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Cuando Todo Recae Sobre Ti + 3 Bonos',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }
        }} className="w-full bg-terracotta hover:bg-terracotta/90 text-white font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center gap-2 text-lg" data-id="element-328">
            QUIERO ACCESO INMEDIATO
            <ArrowRight className="w-5 h-5" data-id="element-329" />
          </a>

          {/* Urgency line */}
          <p className="text-xl md:text-2xl text-terracotta font-bold" data-id="element-330">
            Los 3 bonos desaparecen si cierras esta página.
          </p>
        </motion.div>
      </div>
    </section>;
}